import React from "react";
import Header from "../components/Header";
import RightRail from "../components/RightRail";
import Hero from "../components/Hero";
import ProductGrid from "../components/ProductGrid";
import Footer from "../components/Footer";
import CookieConsent from "../components/CookieConsent";

export default function HomePage() {
  return (
    <div className="min-h-screen text-gray-100 relative">
      {/* Cookie Consent always on top */}
      <CookieConsent />

      <Header />
      <RightRail />
      <main className="pt-20">
        <Hero />
        <ProductGrid />
      </main>
      <Footer />
    </div>
  );
}
